(() => {
  'use strict';

  const BOOSTER_VARIANTS = {
    '3mg': 54510280802645,
    '6mg': 54510280835413
  };
  const FORMAT_CONFIG = {
    auto50ml: {
      format: '50ml',
      label: 'Booster 50 ml',
      units: { '3mg': 1, '6mg': 2 }
    },
    auto100ml: {
      format: '100ml',
      label: 'Booster 100 ml',
      units: { '3mg': 2, '6mg': 4 }
    }
  };
  const shopRoot = window.Shopify?.routes?.root || '/';
  let syncing = false;
  let pending = false;
  let timer = 0;

  const route = (path) => `${shopRoot.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  const normalizeMode = (value) => value === '3mg' || value === '6mg' ? value : null;
  const normalizeOrigin = (value) => Object.prototype.hasOwnProperty.call(FORMAT_CONFIG, value) ? value : null;
  const propertiesOf = (item) => item.properties || {};
  const choiceOf = (item) => normalizeMode(propertiesOf(item)._booster_choice);
  const originOfBooster = (item) => normalizeOrigin(propertiesOf(item)._booster_from);
  const originOfBottle = (item) => propertiesOf(item)._booster_format === '100ml' ? 'auto100ml' : 'auto50ml';
  const linkedVariantOf = (item, mode) => Math.max(0, Number(propertiesOf(item)._booster_variant) || BOOSTER_VARIANTS[mode] || 0);
  const boosterVariantOf = (item, mode) => Math.max(0, Number(item.variant_id || item.id) || BOOSTER_VARIANTS[mode] || 0);
  const unitsOfBottle = (item, mode, origin) => {
    const storedUnits = Number(propertiesOf(item)._booster_unit);
    return storedUnits > 0 ? storedUnits : FORMAT_CONFIG[origin].units[mode];
  };
  const groupKey = (origin, mode, variantId) => `${origin}:${mode}:${variantId}`;
  const isCartPage = () => {
    const current = window.location.pathname.replace(/\/+$/, '');
    const cartPath = new URL(route('cart'), window.location.origin).pathname.replace(/\/+$/, '');
    return current === cartPath;
  };

  async function request(path, options = {}) {
    const response = await window.fetch(route(path), {
      ...options,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...(options.headers || {})
      }
    });
    if (!response.ok) throw new Error(`${path} failed (${response.status})`);
    return response.json();
  }

  const fetchCart = () => request('cart.js');
  const changeLine = (key, quantity) => request('cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  const addBooster = (origin, mode, quantity, linkedVariant) => {
    const config = FORMAT_CONFIG[origin];
    return request('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: linkedVariant || BOOSTER_VARIANTS[mode],
          quantity,
          properties: {
            _ajout_automatique: config.label,
            _booster_from: origin,
            _booster_choice: mode,
            _booster_unit: String(config.units[mode]),
            _dosage_choisi: mode.replace('mg', ' mg')
          }
        }]
      })
    });
  };

  async function syncBoostersNow() {
    if (syncing) {
      pending = true;
      return;
    }
    syncing = true;
    let changed = false;

    try {
      const cart = await fetchCart();
      const bottlesByGroup = new Map();
      const boostersByGroup = new Map();

      for (const item of cart.items || []) {
        const mode = choiceOf(item);
        if (!mode) continue;

        const boosterOrigin = originOfBooster(item);
        if (boosterOrigin) {
          const variantId = boosterVariantOf(item, mode);
          const key = groupKey(boosterOrigin, mode, variantId);
          if (!boostersByGroup.has(key)) boostersByGroup.set(key, []);
          boostersByGroup.get(key).push(item);
          continue;
        }

        const origin = originOfBottle(item);
        const variantId = linkedVariantOf(item, mode);
        const key = groupKey(origin, mode, variantId);
        const linked = bottlesByGroup.get(key) || { origin, mode, variantId, quantity: 0 };
        linked.quantity += Number(item.quantity || 0) * unitsOfBottle(item, mode, origin);
        bottlesByGroup.set(key, linked);
      }

      for (const [key, bottle] of bottlesByGroup) {
        const desired = bottle.quantity;
        const lines = boostersByGroup.get(key) || [];

        if (!lines.length && desired > 0) {
          await addBooster(bottle.origin, bottle.mode, desired, bottle.variantId);
          changed = true;
          continue;
        }

        const [keeper, ...duplicates] = lines;
        if (keeper && Number(keeper.quantity) !== desired) {
          await changeLine(keeper.key, desired);
          changed = true;
        }
        for (const duplicate of duplicates) {
          await changeLine(duplicate.key, 0);
          changed = true;
        }
      }

      for (const [key, lines] of boostersByGroup) {
        if (bottlesByGroup.has(key)) continue;
        for (const item of lines) {
          await changeLine(item.key, 0);
          changed = true;
        }
      }

      if (changed) {
        if (isCartPage()) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (error) {
      console.warn('[ClassClope BoosterGuard]', error);
    } finally {
      syncing = false;
      if (pending) {
        pending = false;
        schedule(120);
      }
    }
  }

  function schedule(delay = 240) {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncBoostersNow, delay);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule());
  }

  document.addEventListener('cc:booster:added', () => schedule(80));
  document.addEventListener('cart:refresh', () => schedule());
  document.addEventListener('cc:booster:sync', () => schedule(0));
})();
